// Outbound notifications to the school admin via Web3Forms.
// Kept in a dedicated module to keep page components (Dashboard, etc.) small.

const WEB3FORMS_KEY = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;
const ADMIN_DASHBOARD_URL = "https://mylafayetteadmissions.com/admin";
const NA = "(non renseigné)";

const fallback = (v, dft = NA) => (v == null || v === "" ? dft : v);

function fullStudentName(student) {
  const name = `${student?.firstname || ""} ${student?.lastname || ""}`.trim();
  return name || "(nom élève manquant)";
}

function parentDisplayName(parents, parentUser) {
  return parents?.father_name || parents?.mother_name || parentUser?.name || "";
}

function parentPhone(parents) {
  return fallback(parents?.father_phone || parents?.mother_phone);
}

function buildStudentBlock(student) {
  return [
    "── ÉLÈVE ──",
    `Nom complet : ${fullStudentName(student)}`,
    `Date de naissance : ${fallback(student?.date_of_birth)}`,
    `Niveau demandé : ${fallback(student?.level_requested)}`,
    `Établissement précédent : ${fallback(student?.previous_school)}`,
  ];
}

function buildParentsBlock(parents, parentUser) {
  return [
    "── PARENTS ──",
    `Père : ${fallback(parents?.father_name, "—")} (${fallback(parents?.father_phone, "—")})`,
    `Mère : ${fallback(parents?.mother_name, "—")} (${fallback(parents?.mother_phone, "—")})`,
    `Email parent : ${fallback(parentUser?.email, "—")}`,
    `Adresse : ${fallback(parents?.address, "—")}, ${fallback(parents?.city, "—")}`,
  ];
}

function buildActionBlock(dossierId) {
  return [
    "── ACTION REQUISE ──",
    "Connectez-vous à l'espace administrateur pour examiner et valider les pièces :",
    ADMIN_DASHBOARD_URL,
    "",
    `ID dossier : ${fallback(dossierId, "—")}`,
  ];
}

function buildSubmissionBody(parentUser, dossier) {
  const student = dossier?.student || {};
  const parents = dossier?.parents || {};
  return [
    "Un nouveau dossier d'inscription vient d'être soumis pour validation administrative.",
    "",
    ...buildStudentBlock(student),
    "",
    ...buildParentsBlock(parents, parentUser),
    "",
    ...buildActionBlock(dossier?.id),
  ].join("\n");
}

function buildFormData(parentUser, dossier) {
  const student = dossier?.student || {};
  const parents = dossier?.parents || {};
  const fd = new FormData();
  fd.append("access_key", WEB3FORMS_KEY);
  fd.append("subject", `[MyLafayette] Dossier soumis pour validation — ${fullStudentName(student)}`);
  fd.append("from_name", "MyLafayette Admissions");
  fd.append("replyto", parentUser?.email || "");
  fd.append("name", parentDisplayName(parents, parentUser));
  fd.append("email", parentUser?.email || "");
  fd.append("phone", parentPhone(parents));
  fd.append("grade", student.level_requested || "(niveau non renseigné)");
  fd.append("message", buildSubmissionBody(parentUser, dossier));
  fd.append("botcheck", "");
  return fd;
}

export async function notifyAdminOfDossierSubmission(parentUser, dossier) {
  if (!WEB3FORMS_KEY) return false;
  try {
    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: buildFormData(parentUser, dossier),
    });
    const json = await res.json().catch(() => ({}));
    return res.ok && json.success === true;
  } catch (_err) {
    return false;
  }
}
